var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5H5ZM5 5H3ZM5 5V3ZM5 5V7Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5H5M5 5H3M5 5V3M5 5V7",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.46128 1.09544C2.35812 0.936774 2.4026 0.723396 2.56795 0.631338C3.54365 0.0881248 4.67663 -0.114413 5.78596 0.0621603C7.00844 0.256745 8.11529 0.897889 8.89229 1.86152C9.6693 2.82515 10.0612 4.04275 9.99223 5.2787C9.92323 6.51464 9.39821 7.68106 8.51877 8.55221C7.63934 9.42337 6.46801 9.93733 5.23147 9.99464C3.99492 10.0519 2.78108 9.64852 1.82484 8.86243C0.868607 8.07635 0.23796 6.96349 0.0549472 5.73922C-0.111126 4.62827 0.102119 3.49726 0.654537 2.52674C0.748155 2.36226 0.961944 2.3198 1.11962 2.42446V2.42446C1.2773 2.52912 1.31896 2.74122 1.22714 2.9067C0.767564 3.73497 0.591775 4.69481 0.732755 5.6379C0.890683 6.69436 1.43489 7.65468 2.26006 8.33302C3.08523 9.01136 4.13269 9.35949 5.19974 9.31003C6.26679 9.26058 7.27757 8.81707 8.03646 8.06532C8.79536 7.31357 9.24841 6.30704 9.30795 5.2405C9.36749 4.17396 9.02929 3.12325 8.35878 2.2917C7.68828 1.46016 6.73315 0.906893 5.67823 0.73898C4.73652 0.589086 3.77506 0.755788 2.94248 1.20751C2.77614 1.29776 2.56444 1.2541 2.46128 1.09544V1.09544Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.8402b9d408c8b8640b307aa9486165e1.svg";
export { ForwardRef as ReactComponent };